<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row class="pa-0 ma-0">
          <v-tabs
            vertical
          >
            <v-tab>
              {{ $t('configControl') }}
            </v-tab>
            <v-tab-item>
              <v-container>
                <v-col
                  v-if="!items"
                  cols="12"
                >
                  <v-text-field
                    v-model="password"
                    :label="$t('password')"
                    outlined
                    clearable
                    dense
                  />
                </v-col>
                <div
                  v-if="password == 'mehrad@36679'"
                >
                  <v-col
                    v-for="(item, index) in items"
                    :key="index"
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="item.value"
                      :label="$t(item.key)"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                </div>
              </v-container>
            </v-tab-item>
          </v-tabs>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              color="grey"
              outlined
              class="float-left"
              @click="$emit('close')"
            >
              {{ $t('cancel') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : '')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  // import aicomplete from '../../components/general/AIcomplete/index'
  // import autocomplete from '../../components/general/patial/autocomplete'
  import General from '../../../../Mixins/general'
  export default {
    name: 'Customer',
    components: {
      // aicomplete,
      // autocomplete,
    },
    mixins: [General],
    data: () => ({
      valid: true,
      configControl: true,
      password: null,
      items: null,
      type: null,
      render: true,
      isLoading: false,
    }),
    watch: {
      password () {
        if (this.password === 'mehrad@36679') {
          this.isLoading = true
          this.show()
        }
      },
    },
    activated () {
    },
    beforeMount () {
    },
    mounted () {
    },
    methods: {
      remove (index) {
        this.paymentItems.splice(index, 1)
      },
      update () {
        var app = this
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'setting/' + 0, this.$data)
          .then(res => {
            res = res.data
            app.snakbarText = app.$t('registered')
            app.snakbarColor = 'green'
            app.snakbar = true
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
      show () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'setting', {
          params: {
            getall: 'yes',
          },
        })
          .then(res => {
            app.$nextTick(() => {
              res = res.data
              app.items = res
              // app.webhookProductStore = res.webhookProductStore
              app.render = true
            })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            app.isLoading = false
            app.loading = false
          })
      },
    },
  }
</script>

<style scoped>
.col{
  height: 55px !important;
}
</style>
